import React, { ReactNode } from 'react';

import { DetailsSlideDown, Content } from './styles';

type Props = {
  open?: boolean;
  children: ReactNode;
};

const Details = ({ open, children }: Props) => (
  <>
    <DetailsSlideDown transitionOnAppear={false} closed={!open}>
      <Content>{children}</Content>
    </DetailsSlideDown>
  </>
);

export default Details;
